import React from 'react';

const EventCardSkeleton: React.FC = () => {
  return (
    <div className="flex flex-col relative">
      <div className="group rounded-3xl transition-all duration-300 ease-in-out h-full">
        <div className="flex flex-col h-full">
          {/* Header skeleton - matching EventCardHeader structure */}
          <div className="relative flex flex-row items-center justify-between p-2 md:p-3 gap-2 md:gap-3">
            <div className="flex items-center gap-2 md:gap-3 flex-1 min-w-0">
              <div className="w-[40px] h-[40px] bg-gray-200 rounded-lg animate-pulse flex-shrink-0" />
              <div className="flex flex-col gap-1 flex-1 min-w-0">
                <div className="h-4 bg-gray-200 rounded w-32 animate-pulse" />
                <div className="h-4 bg-gray-200 rounded w-40 animate-pulse" />
              </div>
            </div>
            <div className="h-6 w-6 bg-gray-200 rounded animate-pulse flex-shrink-0" />
          </div>

          {/* Main card skeleton */}
          <div className="flex flex-col rounded-3xl md:border border-gray-200 w-full md:h-[450px] md:w-[360px] flex-1 relative md:overflow-hidden">
            {/* Image skeleton */}
            <div className="w-full h-[450px] bg-gray-200 animate-pulse" />

            {/* Date badge skeleton */}
            <div className="absolute top-4 right-4 z-20 bg-gray-300 opacity-80 rounded-2xl">
              <div className="flex flex-col items-center py-2 px-4 justify-center">
                <div className="h-4 bg-gray-400 rounded w-8 animate-pulse mb-1" />
                <div className="h-6 bg-gray-400 rounded w-6 animate-pulse" />
              </div>
            </div>

            {/* Guests count skeleton */}
            <div className="absolute bottom-2 left-[50%] translate-x-[-50%] flex flex-row items-center">
              <div className="h-5 bg-gray-300 rounded w-12 animate-pulse" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventCardSkeleton;
